import { FilterItem } from '@wconcept/wconcept-common/models/renewal/common';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import FltChkItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/FltChkItem';
import FltBenefitBox from '../../_list/FltBenefitBox';

function TpoContent({
  tpoList,
  isItemSelected,
  onChangeTpo,
}: {
  tpoList?: FilterItem[] | null;
  isItemSelected: (filterType: string, item: FilterItem) => boolean;
  onChangeTpo: (tpo: FilterItem) => void;
}) {
  return (
    <Box className="coner-tpo">
      <FltBenefitBox
        items={tpoList?.map((tpo: FilterItem) => (
          <FltChkItem
            key={tpo.code}
            value={tpo.code}
            checked={isItemSelected('tpo', tpo)}
            name={tpo.name}
            cnt={tpo.count}
            onChange={() => onChangeTpo(tpo)}
          />
        ))}
      />
    </Box>
  );
}

export default TpoContent;
